/** Shared Ant Design Card classNames for billing pages on narrow viewports */
export const SUBSCRIPTION_OUTER_CARD_CLASS =
    "subscription-card min-w-0 w-full max-w-full !rounded-2xl !border-[#ECECF3] [&_.ant-card-head-title]:!whitespace-normal [&_.ant-card-head-title]:!overflow-visible [&_.ant-card-head]:!min-w-0 [&_.ant-card-head]:!px-3 [&_.ant-card-head]:!py-3 sm:[&_.ant-card-head]:!px-6 [&_.ant-card-body]:!min-w-0 [&_.ant-card-body]:!p-3 sm:[&_.ant-card-body]:!p-6";

export const SUBSCRIPTION_INNER_CARD_CLASS =
    "min-w-0 !rounded-xl !border-[#ECECF3] [&_.ant-card-head-title]:!whitespace-normal [&_.ant-card-head-title]:!overflow-visible [&_.ant-card-head]:!min-w-0 [&_.ant-card-body]:!min-w-0";

export const subscriptionCardTitle = (text) => (
    <span className="block text-[16px] font-semibold leading-snug text-[#2F2F46]">{text}</span>
);
